const FIRST_TAGLINE = 'угадай по кадру';
const LAST_TAGLINE_KEY = 'uznali:last-brand-tagline';

const BRAND_TAGLINES = [
  FIRST_TAGLINE,
  'возможны спойлеры!',
  'согласны?',
  'да этот, как его там...',
  'я это точно видел...',
  'это из какой серии?',
] as const;

const pickBrandTagline = () => {
  if (typeof window === 'undefined') return FIRST_TAGLINE;

  try {
    const previous = window.localStorage.getItem(LAST_TAGLINE_KEY);
    if (previous === null) {
      window.localStorage.setItem(LAST_TAGLINE_KEY, FIRST_TAGLINE);
      return FIRST_TAGLINE;
    }

    const choices = BRAND_TAGLINES.filter((tagline) => tagline !== previous);
    const next = choices[Math.floor(Math.random() * choices.length)] ?? FIRST_TAGLINE;
    window.localStorage.setItem(LAST_TAGLINE_KEY, next);
    return next;
  } catch {
    return FIRST_TAGLINE;
  }
};

// Shared module state keeps the line stable while navigating between routes.
export const brandTagline = pickBrandTagline();
